
export const FormValidation = ({ inputField, setErrField }) => {
    const validateForm = () => {
        let errors = {};
        
        if (!inputField?.password?.trim()) {
            errors.passwordErr = "Please enter password";
        }
        if (!inputField?.confirmPassword?.trim()) {
            errors.confirmPasswordErr = "Please enter confirmed password";
        }
        setErrField(errors);
        return Object.keys(errors)?.length === 0;
    };

    return validateForm();
};

export const FormValidationOnChange = ({ inputValue, setErrField, inputName }) => {
    const validateForm = () => {

        if (inputName === "password" && inputValue?.length > 3) {
            setErrField((prevState) => ({
                ...prevState,
                passwordErr: "",
            }));
        }
        if (inputName === "confirmPassword" && inputValue?.length > 5) {
            setErrField((prevState) => ({
                ...prevState,
                confirmPasswordErr: "",
            }));
        }
    };

    return validateForm();
};

